<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/94onEu/tc-custom/9780795347450.jpg?1696062847415" alt="This image is the cover for the book Iconic Cars: Porsche, Car and Driver Iconic Cars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Iconic Cars: Porsche, Car and Driver Iconic Cars
      </h1>
      <p class="bookDescription body article font2">
        <b>This fully illustrated volume of road tests, reviews and more from the experts at <i>Car and Driver</i> covers nearly half a century of Porsche excellence.</b><br/>  <br/> For decades, the company started by Ferdinand Porsche has produced some of the best sportscars money can buy. The Porsche name has come to stand for automotive power, beauty, and prestige. <i>Car and Driver</i> has chronicled the German brand from its first commercial automobile, the 356 Roadster, to its modern lineup of supercars, super sedans, and even super SUVs. <br/>  <br/> Now the magazine has collected its most important, informative, and entertaining Porsche articles in one volume. These reviews, features, road tests and comparisons cover the car maker’s evolution from 1975 to today. The articles are accompanied by 79 original photos in bright color or crisp black and white.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Car and Driver
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02964d8f